<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      Create New Project
      <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <form [formGroup]="projectForm" autocomplete="off">
      <div class="row m-0 eip-pt-20">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Project Description</mat-label>
                  <input matInput formControlName="projDesc" required>
                  <mat-error *ngIf=" (projectForm.get('projDesc').dirty || projectForm.get('projDesc').touched) && projectForm.get('projDesc').hasError('required')">
                      Project description is required
                  </mat-error>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Project Short Description</mat-label>
                  <input matInput formControlName="projShortDesc" required>
                  <mat-error *ngIf="projectForm.get('projShortDesc').hasError('required')">
                      Project Short Description is required
                  </mat-error>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Project Code</mat-label>
                  <input matInput formControlName="projCode" required>
                  <mat-error *ngIf="projectForm.get('projCode').hasError('required')">
                      Project Code is required
                  </mat-error>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Job Code</mat-label>
                  <input matInput formControlName="jobCode" required>
                  <mat-error *ngIf="projectForm.get('jobCode').hasError('required')">
                      Job Code is required
                  </mat-error>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Project URL</mat-label>
                  <input matInput formControlName="projUrl" required>
                  <mat-error *ngIf="projectForm.get('projUrl').hasError('required')">
                      Project url is required
                  </mat-error>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Project Logo URL</mat-label>
                  <input matInput formControlName="projLogoUrl">
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <EIPDateRangePicker [IsSelectionRequired]=true [valueStart]=projStartDate [valueEnd]=projEndDate setid="dtRangeDate" WaterMark="Project Start & End Date" (selectedStartDate)='getStartDateValue($event)' (selectedEndDate)='getEndDateValue($event)'>
              </EIPDateRangePicker>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <EIPAutoComplete formControlName="ICId" style="padding-right: 20px;" ShowTextValueField='N' floatLabelOption="never" TextField="dedDescription"  ValueField="dedId" WaterMarkText="Select IC *" [dataSource]='icList' (valueChange)='changeIc($event)' setId="iC_Id" [IsCascading]='true' required>
              </EIPAutoComplete>
              <mat-error *ngIf="projectForm.get('ICId').touched && projectForm.get('ICId').hasError('required')" style="margin-top: -42px;">
                  IC is required
              </mat-error>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Client</mat-label>
                  <input matInput formControlName="client">
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>Consultant</mat-label>
                  <input matInput formControlName="consultant">
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field style="width: 100%;">
                  <mat-label>ISOFormatNo</mat-label>
                  <input matInput formControlName="isoNo">
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field style="width: 100%;">
                <mat-label>Latitude</mat-label>
                <input matInput formControlName="latitude" (keydown)="onKeyPress($event)">
            </mat-form-field>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <mat-form-field style="width: 100%;">
                <mat-label>Longitude</mat-label>
                <input matInput formControlName="longitude" (keydown)="onKeyPress($event)">
            </mat-form-field>
        </div>
          <div *ngIf="visible_BG" class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <EIPAutoComplete formControlName="businessGroup" style="padding-right: 20px;" ShowTextValueField='N' floatLabelOption="never" TextField="group_Name"  ValueField="group_Id" WaterMarkText="Select Business Group *" [dataSource]='businessGroups' setId="groupid" (valueChange)='changebusinessGroup($event)' [IsCascading]='true' required>
              </EIPAutoComplete>
              <mat-error *ngIf="projectForm.get('businessGroup').touched && projectForm.get('businessGroup').hasError('required')" style="margin-top: -42px;">
                  BusinessGroup is required
              </mat-error>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Active Status</mat-label>
                  <mat-slide-toggle color="primary" formControlName="projStatus">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Is Cloud Storage</mat-label>
                  <mat-slide-toggle color="primary" formControlName="projIsCloudStorage">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea>
              </mat-form-field>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <mat-label class="font-weight-bold eip-mr-20">Numbering Format : </mat-label>
              <mat-button-toggle-group aria-label="Numbering Format" class="com-semiauto" [value]='numFormat' formControlName="Doc_Number_Format">
                  <mat-button-toggle value="Semi" aria-checked="true">Semi</mat-button-toggle>
                  <mat-button-toggle value="Manual">Manual</mat-button-toggle>
                  <mat-button-toggle value="Auto">Auto</mat-button-toggle>
              </mat-button-toggle-group>
          </div>
      </div>
  </form>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button (click)="saveProject()" class="btn btn-primary" [disabled]="!projectForm.valid" type="submit" id="btnEDMSave"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;{{actionButtonText}}</button>&nbsp;
      <button (click)="closeDialog()" class="btn btn-secondary" id="btnEDMCancel"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button>
  </div>
</div>